import React from "react";
import { useTheme } from "styled-components";
import { Button } from "../../Button";
import { Icon } from "../../Icon";
export const CollapsePanelButton = ({ setCollapsed, isCollapsed, }) => {
    const { colors: { flyoutColors }, } = useTheme();
    return (React.createElement(Button, { backgroundColor: flyoutColors.collapsePanelButtonBackground, border: `1px solid ${flyoutColors.collpasePanelButtonBorder}`, borderRadius: "5px 0 0 5px", color: flyoutColors.collapsePanelArrowcolor, height: "80px", onClick: () => setCollapsed(!isCollapsed), size: "icon", textStyle: "greyIcon", variant: "iconWithoutBorder", sx: {
            "&:hover": {
                backgroundColor: flyoutColors.collapsePanelButtonBackgroundHover,
            },
            backdropFilter: "blur(32px)",
        }, "data-testid": "collapsePanelButton" },
        React.createElement(Icon, { src: isCollapsed ? "ChevronDoubleLeft" : "ChevronDoubleRight", size: 15 })));
};
